// ============================================================================
// Adds custom increment functionality
// ============================================================================
// TODO: It would be nice if this didn't live here in theme.js

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    const $formInput = $('.form__input[type="number"]');
    
    function hideMaxError () {
        setTimeout(() => {
            $('.cart__message--error').text('');
        }, 4000);
    }

    if ($formInput) {
        $('.form__increment').on('click', function() {
            clearTimeout(hideMaxError);
            
            var $button = $(this);
            var oldValue = $button.parent().find('input').val();

            $button.parent().find('input').focus();

            if ($button.hasClass('form__increment--up')) {
                if (oldValue < 100) {
                    $button.removeClass('disabled');
                    var newVal = parseFloat(oldValue) + 1;
                } else {
                    var newVal = oldValue;
                    $button.addClass('disabled');
                    $('.cart__message--error').text(window.translations.maxItemsInCart);
                    hideMaxError();
                }
            }
            else {
                $button.parent().find('.form__increment--up').removeClass('disabled');
                
                // Don't allow decrementing below zero
                if (oldValue > 1) {
                    var newVal = parseFloat(oldValue) - 1;
                } else {
                    newVal = 1;
                }
            }

            $button.parent().find('input').val(newVal).trigger('change');
            $('button[name=update_cart]').prop('disabled', false);

        });
    }
});
